import { css } from '@emotion/react';
import { navigate, PageProps } from 'gatsby';
import { useEffect } from 'react';
import { ContactPageTemplate } from '@/components/contact/ContactPageTemplate';
import { EstimateForm } from '@/components/form/EstimateForm';
import { Layout } from '@/components/general/Layout';
import { Seo } from '@/components/general/Seo';
import { pagesPath } from '@/lib/pagesPath';
import { useFormStorage } from '@/lib/use-form-storage';
import { getScreen } from '@/styles/media-query';

const Page: React.FC<PageProps> = ({ location }) => {
  const { getFormStorage, setFormStorage, cleanFormStorage } = useFormStorage();
  const formState = getFormStorage();

  useEffect(() => {
    if (formState) {
      return () => {
        cleanFormStorage();
      };
    }
  }, []);
  return (
    <Layout location={location}>
      <Seo
        title="各プランに関するご相談"
        description="【Uniforce】IPO準備クラウドのサービス資料へのお申し込み、お見積りのご依頼はこちらから。内容確認後、担当より通常1営業日以内にご連絡いたします。"
        meta={[
          {
            name: 'robots',
            content: 'noindex, nofollow',
          },
          {
            name: 'googlebot',
            content: 'noindex, nofollow',
          },
        ]}
      />
      <ContactPageTemplate
        title="各プランに関するご相談"
        titleEn="CONTACT"
        titleReadText={
          <>
            Uniforce IPO準備クラウドでは、
            <br
              css={css`
                @media ${getScreen('pc')} {
                  display: none;
                }
              `}
            />
            IPO準備の作業漏れをなくし、
            <br />
            事前に必要な作業を把握することで
            <br
              css={css`
                @media ${getScreen('pc')} {
                  display: none;
                }
              `}
            />
            円滑な進行を実現することが可能です。
          </>
        }
        sideTitleEn="Point"
        sideTitleJa="Uniforce導入のメリット"
        sideItems={[
          '上場経験がなくてもスムーズに準備を進められるようになる',
          '成長を視野に入れた内部統制構築・運用ができるようになる',
          '監査契約前に自社の内部統制状況をセルフチェックできる',
          '公認会計士によるIPO準備業務の徹底サポートを受けられる',
        ]}
        type="estimate"
      >
        <EstimateForm
          initFormState={{
            plan: 'ベーシックプラン',
            ...formState,
            agree_flag: false,
          }}
          submitHandler={async (state) => {
            setFormStorage(state);
            await navigate(pagesPath.estimate.confirmation.$url());
          }}
        />
      </ContactPageTemplate>
    </Layout>
  );
};

export default Page;
